module.exports = __webpack_public_path__ + "static/media/faviconLeparc.de19d411.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/faviconLeparc.png
// module id = 1547
// module chunks = 0